export default {
  show: "step1",
  showCookie: false,
};
